
import * as React from "react";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { ThemeBreakpoints, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { LinkProps } from "@vwpfs/mary-air-lib/components/air/05-atoms/Link";
import { Blockquote } from "@vwpfs/mary-air-lib/components/air/05-atoms/Blockquote";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { Icon, IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { Card } from "@vwpfs/mary-air-lib/components/air/07-organisms/Card";


interface OwnProps {
    title?: string;
    link: LinkProps;
}

/**
 *
 */
type Props = OwnProps;

export const Failed: React.FunctionComponent<Props> = props => (
    <Card
        title={"Generation Failed"}
        collapsable={false}
        defaultCollapsed={false}
    >
        <Container
            theme={{
                palette: ThemePalette.CONTRAST_PRIMARY,
                padding: {
                    "": { y: 3 },
                    "sm": { y: 4 },
                },
            }}
        >
            <Blockquote>
                <h4>
                    {props.title ? props.title : "Something went wrong"},
                </h4><br/>
                <div className="scl-h-text--big">We couldn&apos;t generate the report.</div>
                <br/>
                <div className="scl-h-text--big">
                        Claude suggests to continue and try again.
                </div>
            </Blockquote>
            <ButtonsWrapper
                defaultOrientation={Orientation.HORIZONTAL}
                orientations={{
                    [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                    [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                }}
                alignment={Alignment.RIGHT}
            >
                <Button
                    theme={{ palette: ThemePalette.BRAND_ACCENT }}
                    className="scl-a-btn--big"
                    buttonType="button"
                    link={props.link}
                >
                        Continue
                        &nbsp;&nbsp;
                    <Icon name={IconNames.ARROW_RIGHT} />
                </Button>
            </ButtonsWrapper>
        </Container>
    </Card>
);
